import { render, staticRenderFns } from "./EvrakIndirView.vue?vue&type=template&id=a828d562"
import script from "./EvrakIndirView.vue?vue&type=script&lang=ts"
export * from "./EvrakIndirView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports